import { Spin } from 'antd';

const FullScreenSpinner = ({ spinning }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.8)', // semi-transparent white background
    zIndex: 1000, // set a high z-index to make sure it's on top
    visibility: spinning ? 'visible' : 'hidden',
    opacity: spinning ? 1 : 0,
    transition: 'visibility 0s, opacity 0.5s linear'
  }}>
    <Spin size="large" style={{ fontSize: '2em' }}/>
  </div>
);

export default FullScreenSpinner;
